import '../product-card/product-card-display';
import '../search/search-results';

import { html, nothing, PropertyValueMap } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { connect } from 'pwa-helpers';
import { BaseComponent } from '../base-component/base-component';
import store from '../../store/store';
import { booleanConverter } from '../../common/converters';
import { SearchResultLargeCardData } from '../product-card/product-card-display';
import { SearchV2Result } from './interface/search-v2.interface';
import { StoreState } from '../../store/store.interface';
import { isSuccess, searchParam, selectSearchV2Reasults } from './store/search-v2.selectors';
import "../tabbed-search/tabbed-search-result/tabbed-suggestion-search-result";

/**
 * An element to perform plp search using program code
 *
 * @csspart programCode - program code on which search result will be performed.
 *
 */
@customElement('mhecomm-search-v2-results')
export class SearchV2Results extends connect(store)(BaseComponent) {
  @property({ converter: booleanConverter })
  autoLoad = false;

  @property() 
  selectedTabName = "";

  @state()
  private searchV2ResultsCard: Array<SearchResultLargeCardData> = [];

  @state()
  private resultsFromSearchV2: Array<SearchV2Result> = [];

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties);
    if (this.autoLoad) {
      //dispatch the new api here
    }
  }

  stateChanged(state: StoreState) {
    this.resultsFromSearchV2 = selectSearchV2Reasults(state) || [];
    this.searchV2ResultsCard = this.getSearchResultV2CardData(this.resultsFromSearchV2);
  }

  renderComp() {
    return html`
      <div tabindex="-1" role="region" aria-label="Results">
        ${this.productCardList()} ${this.noResultTemplate()}
      </div>
    `;
  }

  productCardList() {
    return html`
      ${this.searchV2ResultsCard.map(
        (content) => html`
          <mhecomm-product-card-display
            exportparts="heading, container, image, header, details, add-to-cart, link"
            variation="large-card"
            .searchResult="${content}"
            view="largeResultCard"
            class="col">
          </mhecomm-product-card-display>
        `
      )}
    `;
  }

  private getNoResultsMessage(): string {
    return this.selectedTabName ? `No Results Found in ${this.selectedTabName}` : 'No Results Found';
  }

  private noResultTemplate() {
    return html` ${isSuccess(store.getState() as StoreState) && this.searchV2ResultsCard?.length === 0
      ? html`
      <div id="custom-isbn-search-message" class="mt-4">
        <h1 class="fw-semibold h3">${this.getNoResultsMessage()}</h1>
        <div><p class="fs-large">Check your spelling or try another search with different search terms.</p></div>
        ${this.selectedTabName ? html`
          <div class="mt-4">
            <mhecomm-tabbed-suggestion-search-result
              searchterm="${searchParam(store.getState() as StoreState) || ''}"
            ></mhecomm-tabbed-suggestion-search-result>
          </div>
        ` : nothing}
      </div>
    `: nothing}`;
  }

  private normalizeToArray(value?: string | Array<string>): Array<string> {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }
    if (typeof value === 'string') {
      return value
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }
    return [];
  }

  getSearchResultV2CardData(results: Array<SearchV2Result>): Array<SearchResultLargeCardData> {
    return results.map((result) => ({
      title: result.document.title,
      body: result.document.body,
      learning_level: result.document.learning_level,
      businessUnit: result.document.businessUnit,
      product: result.document.product,
      url: result.document.url,
      id: result.document.id,
      documentType: result.document.documentType,
      user_type: this.normalizeToArray(result.document.user_type),
      created_by_division: this.normalizeToArray(result.document.created_by_division),
      tags: this.normalizeToArray(result.document.tags),
    }));
  }
}
declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-search-v2-results': SearchV2Results;
  }
}
